import { faStar } from '@fortawesome/free-regular-svg-icons';
import {
  faReply,
  faStar as faStarFilled,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkmark, Delete, EditGlyph } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import React from 'react';

import { sendGAEvent } from 'src/utils';

const CommentControlPanel = ({
  nested,
  permissions,
  closed,
  user,
  activeUser,
  id,
  important,
  parentClosed = false,
  markAsImportant,
  toggleDeleteConfirmationModal,
  toggleCloseConfirmationModal,
  toggleReplyComment,
  toggleEdit,
  isCommentsUpdating,
}) => {
  const {
    add_comment,
    change_issue,
    change_comment,
    change_own_issue,
    change_own_comment,
    delete_own_comment,
    mark_closed_issue,
    mark_important_issue,
    mark_closed_own_issue,
  } = permissions;

  const close_issue =
    (user.username === activeUser && mark_closed_own_issue) ||
    mark_closed_issue;
  const closeIcon = close_issue && (
    <Checkmark color="#000" height="16" id={id} className="noselect" />
  );

  const importantIcon = mark_important_issue && (
    <FontAwesomeIcon
      icon={important ? faStarFilled : faStar}
      className="noselect"
      color="#000"
      height="16"
    />
  );
  let displayEditIcon, displayDeleteIcon; // displayDeleteIcon is used here to check if user can delete his own commnents not issues
  if (!nested) {
    displayEditIcon =
      !closed &&
      ((!!change_own_issue && user.username === activeUser) || !!change_issue);
    displayDeleteIcon = false;
  } else {
    displayEditIcon =
      !parentClosed &&
      ((!!change_own_comment && user.username === activeUser) ||
        !!change_comment);
    displayDeleteIcon =
      !parentClosed && !!delete_own_comment && user.username === activeUser;
  }
  return (
    <React.Fragment>
      {!nested ? (
        <React.Fragment>
          {add_comment && (
            <span
              className="acr-comment-icon-holder reply-comment"
              onClick={toggleReplyComment}
            >
              <FontAwesomeIcon
                icon={faReply}
                className="noselect"
                color="#000"
                height="16"
                id={id}
              />
              <Text className="acr-comment-icon-label">Reply</Text>
            </span>
          )}
          {close_issue && (
            <span
              className="acr-comment-icon-holder close-issue"
              onClick={() =>
                !isCommentsUpdating ? toggleCloseConfirmationModal() : null
              }
            >
              {closeIcon}
              <Text className="acr-comment-icon-label">Close</Text>
            </span>
          )}
          {mark_important_issue && (
            <span
              className="acr-comment-icon-holder mark-important"
              onClick={() => {
                if (!isCommentsUpdating) {
                  sendGAEvent('comment_important_btn_clicked');
                  markAsImportant();
                }
              }}
            >
              {importantIcon}
              <Text className="acr-comment-icon-label">Important</Text>
            </span>
          )}
        </React.Fragment>
      ) : null}

      {displayEditIcon && !closed && (
        <span
          className="acr-comment-icon-holder edit-comment"
          onClick={() => (!isCommentsUpdating ? toggleEdit() : null)}
        >
          <EditGlyph fill="#000" height="16" id={id} className="noselect" />
          <Text className="acr-comment-icon-label">Edit</Text>
        </span>
      )}
      {displayDeleteIcon && (
        <span
          className="acr-comment-icon-holder delete-comment"
          onClick={() =>
            !isCommentsUpdating ? toggleDeleteConfirmationModal() : null
          }
        >
          <Delete fill="#000" id={id} className="noselect" />
          <Text className="acr-comment-icon-label">Delete</Text>
        </span>
      )}
    </React.Fragment>
  );
};

export default CommentControlPanel;
